import React from 'react';
import { BpmnSymbolId } from '../../data/bpmnSymbols';
import {
  BPMN_ACTIVITY_MARKERS,
  BPMN_ICON_MARKUP,
  isBpmnActivitySymbol,
} from '../../data/bpmnIconMarkup';

interface BpmnSymbolIconProps {
  symbolId: BpmnSymbolId;
  size?: number;
  className?: string;
}

const ACTIVITY_FILL = '#c7755b';
const ACTIVITY_STROKE = '#8f4e3a';
const ACTIVITY_MARKER = '#F4EEE8';

/**
 * Official BPMN glyphs from the IconMagic BPMN set
 * (bpmn-font, Open Font License): https://iconmagic.io/iconset/bpmn
 */
export const BpmnSymbolIcon: React.FC<BpmnSymbolIconProps> = ({ symbolId, size = 40, className }) => {
  if (isBpmnActivitySymbol(symbolId)) {
    const marker = BPMN_ACTIVITY_MARKERS[symbolId];
    const strokeWidth = symbolId === 'callActivity' ? 2.4 : 1.2;
    const inset = strokeWidth / 2;
    const markerSize = 11;

    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 36 30"
        className={className}
        aria-hidden
      >
        <rect
          x={inset}
          y={inset}
          width={36 - strokeWidth}
          height={30 - strokeWidth}
          rx={4.5}
          ry={4.5}
          fill={ACTIVITY_FILL}
          stroke={ACTIVITY_STROKE}
          strokeWidth={strokeWidth}
        />
        {marker && (
          <svg
            x={marker.placement === 'bottom-center' ? (36 - markerSize) / 2 : 3.5}
            y={marker.placement === 'bottom-center' ? 30 - markerSize - 2.5 : 3}
            width={markerSize}
            height={markerSize}
            viewBox={marker.viewBox}
            preserveAspectRatio="xMidYMid meet"
          >
            <path d={marker.d} fillRule={marker.fillRule} fill={ACTIVITY_MARKER} />
          </svg>
        )}
      </svg>
    );
  }

  const icon = BPMN_ICON_MARKUP[symbolId];
  if (!icon) return null;

  return (
    <svg
      viewBox={icon.viewBox}
      width={size}
      height={size}
      className={className}
      aria-hidden
      fill="currentColor"
    >
      <path d={icon.d} fillRule={icon.fillRule} />
    </svg>
  );
};

export default BpmnSymbolIcon;
